import React from "react";
const NoPage = () => {
    return (
        <main>
            <div className="error404">
                <h1>Error: 404</h1>
                <h2>Page not found.</h2>
            </div>
        </main>
    );
};
export default NoPage;